import FsDashboard from "./screens/FsDashboard/FsDashboard";
import Tasks from "./screens/Tasks/Tasks";
import PoliciesAndManuals from "./screens/PoliciesAndManuals/PoliciesAndManuals";
import { fireSafetyConfig } from "./screens/PoliciesAndManuals/policiesConfig";
import RiskAssess from "./screens/RiskAssessment/RiskAssess";
import Budgeting from "./screens/Budgeting/Budgeting";
import SafetyEquipment from "./screens/SafetyEquipment/SafetyEquipment";
import EquipmentTypesLanding from "./screens/SafetyEquipment/EquipmentTypesLanding";
import AssetInspection from "./screens/SafetyEquipment/AssetInspection";
import ChecklistManagement from "./screens/SafetyEquipment/ChecklistManagement";
import MISChecklist from "./screens/SafetyEquipment/MISChecklist";
import MISChecklistList from "./screens/SafetyEquipment/MISChecklistList";
import KPIChecklist from "./screens/SafetyEquipment/KPIChecklist";
import KPIChecklistManagement from "./screens/SafetyEquipment/KPIChecklistManagement";
import SplitACChecklistForm from "./screens/SafetyEquipment/SplitACChecklistForm";
import SplitACChecklistList from "./screens/SafetyEquipment/SplitACChecklistList";
// import TrainingAndEval from "./screens/StaffTrainingAndPlan/TrainAndEval";
import FireDrills from "./screens/FireDrills/FireDrills";
import FireSafteyIncident from "./screens/IncidentManagement/FireSafetyIncident";

import IMDashboard from "./screens/IncidentManagement/IMDashboard";
import Incidents from "./screens/IncidentManagement/Incidents";
import Report from "./screens/IncidentManagement/Reports";
import {
  ASSETS_MODULE,
  BUDGET_MODULE,
  FIREDRILL_MODULE,
  FS_DASHBOARD_MODULE,
  INCIDENT_DASHBOARD,
  INCIDENT_LIST,
  INCIDENT_REPORTS,
  INCIDENTS_MODULE,
  POLICY_MODULE,
  RISKASSES_MODULE,
  SAFETYAUDIT_MODULE,
  TASK__MODULE,
  TRAINING_MODULE,
  LAWS_REGULATIONS_MODULE,
  EQUIPMENT_MANAGEMENT_EQUIPMENT_INVENTORY_REGISTRATION,
  EQUIPMENT_MANAGEMENT_DOCUMENTATION_AND_HISTORY,
  EQUIPMENT_MANAGEMENT_MAINTENANCE_SCHEDULING_AND_TRACKING,
  EQUIPMENT_MANAGEMENT_REPORT_AND_ANALYTICS,
  SUPPLIERS,
  EQUIPMENT_MANAGEMENT_TASKS,
  EQUIPMENT_MANAGEMENT_INCIDENT,
  EQUIPMENT_MANAGEMENT_BUDGETING,
  EXTERNAL_EMERGENCY_PREPAREDNESS_DASHBOARD,
  EXTERNAL_EMERGENCY_PREPAREDNESS_RISK_ASSESSMENT,
  UTILITY_SYSTEMS_DASHBOARD,
  PREVENTIVE_PREDICTIVE_MAINTENANCE,
  PROJECT_PLANNING_APPROVALS,
  BUDGETING_COST_CONTROL,
  INFECTION_CONTROL_SAFETY_PLANNING,
  MONITORING_IOT_INTEGRATION,
  SAFETY_FACILITY_ROUNDS_DASHBOARD,
  SECURITY_DASHBOARD,
  SECURITY_ACCESS_ZONES,
  SECURITY_ACCESS_ASSIGNMENTS,
  SECURITY_VISITOR_MANAGEMENT,
  SECURITY_CAMERAS,
  SECURITY_INCIDENTS,
  SECURITY_PARKING,
  SECURITY_COMPLIANCE_AUDIT,
  EXTERNAL_EMERGENCY_PREPAREDNESS_EMERGENCY_RESPONSE_PLANS,
  EXTERNAL_EMERGENCY_PREPAREDNESS_BUSINESS_CONTINUITY_RECOVERY,
  EXTERNAL_EMERGENCY_PREPAREDNESS_TESTING_DRILLS,
  EXTERNAL_EMERGENCY_PREPAREDNESS_EXTERNAL_AGENCIES_COORDINATION,
  EXTERNAL_EMERGENCY_PREPAREDNESS_HAZARD_AND_VULNERABILITY_ASSESSMENT,
  UTILITY_SYSTEMS_ASSET_INVENTORY_TRACKING,
  UTILITY_ASSET_TYPE_LIST,
  UTILITY_SYSTEMS_COMPLIANCE_SAFETY,
  UTILITY_SYSTEMS_SPACE_MANAGEMENT,
  UTILITY_SYSTEMS_CONTRACTOR_VENDOR_MANAGEMENT,
  UTILITY_SYSTEMS_DESIGN_DOCUMENTATION_INTEGRATION,
  EXTERNAL_EMERGENCY_PREPAREDNESS_RESOURCE_FOR_READINESS,
  SAFETY_FACILITY_ROUNDS_PLANNING,
  SAFETY_FACILITY_ROUNDS_CHECKLISTS,
  SAFETY_FACILITY_ROUNDS_ISSUES,
  SAFETY_ROUNDS_TYPES,
  SAFETY_FACILITY_ROUNDS_NOTIFICATIONS,
  SAFETY_FACILITY_ROUNDS_ESCALATION_RULES,
  EXTERNAL_EMERGENCY_PREPAREDNESS_ICS,
  EXTERNAL_EMERGENCY_PREPAREDNESS_INCIDENTS,
  EQUIPMENT_MANAGEMENT_MODULE,
  MONITORING_MODULE,
} from "./constants/modules";
import CreateTraining from "./screens/StaffTrainingAndPlan/CreateTraining";
import TrainingDashboard from "./screens/StaffTrainingAndPlan/TrainingDashboard";
import UpcomingSessions from "./screens/StaffTrainingAndPlan/UpcomingSessions";
import PastEvaluation from "./screens/StaffTrainingAndPlan/PastEvaluation";
import CreateTest from "./screens/StaffTrainingAndPlan/CreateTest";
import StartTest from "./screens/StaffTrainingAndPlan/StartTest";
import TrainingView from "./screens/StaffTrainingAndPlan/TrainingView";
import UpcomingSessionDetails from "./screens/StaffTrainingAndPlan/UpcomingSessionDetails";
import PastEvaluationDetails from "./screens/StaffTrainingAndPlan/PastEvaluationDetails";
import FolderView from "./screens/PoliciesAndManuals/FolderView";
import AttemptTest from "./screens/StaffTrainingAndPlan/AttemptTest";
import UserTrainingAnalytics from "./screens/StaffTrainingAndPlan/UserTrainingAnalytics";
import TrainerStartTest from "./screens/StaffTrainingAndPlan/TrainerStartTest";
import { withTrainingModule } from "./screens/StaffTrainingAndPlan/TrainingModuleContext";
import { FIRE_SAFETY_TRAINING_CONFIG } from "./screens/StaffTrainingAndPlan/moduleConfigs";
import PremisesInformationView from "./screens/LawsAndRegulations/FacilityInformation/PremisesInformationView";
import EquipmentTasks from "./screens/EquipmentManagement/Tasks";
import EquipmentInventoryAndRegistration from "./screens/EquipmentManagement/EquipmentInventoryAndRegistration/EquipmentInventoryAndRegistration";
import DocumentationAndHistory from "./screens/EquipmentManagement/DocumentationAndHistory/DocumentationAndHistory";
import MaintenanceSchedulingAndTracking from "./screens/EquipmentManagement/MaintenanceSchedulingAndTracking/MaintenanceSchedulingAndTracking";
import ReportAndAnalytics from "./screens/EquipmentManagement/ReportingAndAnalytics/ReportAndAnalytics";
import SupplierData from "./screens/MasterDataCats/SuppliersData/SupplierData";
import EquipmentManagementIncident from "./screens/IncidentManagement/EquipmentManagementIncident";
import KPIScoreCard from "./screens/SafetyEquipment/KPIScoreCard";
import KPIScoreCardList from "./screens/SafetyEquipment/KPIScoreCardList";
import ElectricalSafetyScorecard from "./screens/SafetyEquipment/ElectricalSafetyScorecard";
import ElectricalSafetyScorecardList from "./screens/SafetyEquipment/ElectricalSafetyScorecardList";
import CheckList from "./screens/FireSafetyAudits/CheckList";
import CreateCheckList from "./screens/FireSafetyAudits/CreateCheckList";
import ViewCheckList from "./screens/FireSafetyAudits/ViewCheckList";
import ExternalEmergencyPreparednessDashboard from "./screens/ExternalEmergencyPreparedness/ExternalEmergencyPreparednessDashboard";
import UtilitySystemsDashboard from "./screens/UtilitySystems/UtilitySystemsDashboard";
import MaintenanceScheduleList from "./screens/UtilitySystems/PreventivePredictiveMaintenance/MaintenanceScheduleList";
import MaintenanceLogList from "./screens/UtilitySystems/PreventivePredictiveMaintenance/MaintenanceLogList";
import ProjectList from "./screens/UtilitySystems/ProjectPlanning/ProjectList";
import InfectionControlChecklistList from "./screens/UtilitySystems/InfectionControl/InfectionControlChecklistList";
import IoTDashboard from "./screens/UtilitySystems/MonitoringIoT/IoTDashboard";
import ProjectPhaseList from "./screens/UtilitySystems/BudgetingCostControl/ProjectPhaseList";
import ProjectPhaseDashboard from "./screens/UtilitySystems/BudgetingCostControl/ProjectPhaseDashboard";
import SafetyFacilityRoundsDashboard from "./screens/SafetyFacilityRounds/SafetyFacilityRoundsDashboard";
import SecurityDashboard from "./screens/Security/Dashboard/SecurityDashboard";
import AccessControlHub from "./screens/Security/AccessControl/AccessControlHub";
import AccessZones from "./screens/Security/AccessControl/AccessZones/AccessZones";
import AccessAssignments from "./screens/Security/AccessControl/AccessAssignments/AccessAssignments";
import AccessLogs from "./screens/Security/AccessControl/AccessLogs/AccessLogs";
import VisitorManagement from "./screens/Security/VisitorManagement/VisitorManagement";
import SurveillanceHub from "./screens/Security/Surveillance/SurveillanceHub";
import Cameras from "./screens/Security/Surveillance/Cameras";
import CameraLivePlayback from "./screens/Security/Surveillance/CameraLivePlayback";
import SurveillanceHealth from "./screens/Security/Surveillance/SurveillanceHealth";
import MotionAlertsScreen from "./screens/Security/Surveillance/MotionAlertsScreen";
import CrowdHeatmapScreen from "./screens/Security/Surveillance/CrowdHeatmapScreen";
import SurveillanceVmsScreen from "./screens/Security/Surveillance/SurveillanceVmsScreen";
import IncidentVideoClipsScreen from "./screens/Security/Surveillance/IncidentVideoClipsScreen";
import SecurityIncidents from "./screens/Security/Incidents/SecurityIncidents";
import ParkingManagement from "./screens/Security/Parking/ParkingManagement";
import ComplianceAuditReport from "./screens/Security/ComplianceAudit/ComplianceAuditReport";
import CommandCenterDashboard from "./screens/Security/CommandCenter/CommandCenterDashboard";
import AssetSecurity from "./screens/Security/AssetSecurity/AssetSecurity";
import StaffSafety from "./screens/Security/StaffSafety/StaffSafety";
import CyberPhysicalHub from "./screens/Security/CyberPhysicalSecurityIntegration/CyberPhysicalHub";
import PredictiveSecurityHub from "./screens/Security/AiPredectiveSecurity/PredictiveSecurityHub";
import SecurityIntegrations from "./screens/Security/Integrations/SecurityIntegrations";
import EmergencyResponsePlans from "./screens/ExternalEmergencyPreparedness/EmergencyResponsePlans/EmergencyResponsePlans";
import AddResponsePlan from "./screens/ExternalEmergencyPreparedness/EmergencyResponsePlans/AddResponsePlan";
import ExternalAgenciesCoordination from "./screens/ExternalEmergencyPreparedness/ExternalAgenciesCoordination/ExternalAgenciesCoordination";
import HazardAndVulnerabilityAssessment from "./screens/RiskAssessment/HazardAndVulnerabilityAssessment/HazardAndVulnerability";
import BCPPlans from "./screens/ExternalEmergencyPreparedness/BusinessContinuityRecovery/BCPPlans";
import AddEditBCPPlan from "./screens/ExternalEmergencyPreparedness/BusinessContinuityRecovery/AddEditBCPPlan";
import RecoveryTasks from "./screens/ExternalEmergencyPreparedness/BusinessContinuityRecovery/RecoveryTasks";
import AddEditRecoveryTask from "./screens/ExternalEmergencyPreparedness/BusinessContinuityRecovery/AddEditRecoveryTask";
import RecoveryTimeline from "./screens/ExternalEmergencyPreparedness/BusinessContinuityRecovery/RecoveryTimeline";

// Emergency Preparedness - Communication & Notification
import EmergencyNotifications from "./screens/ExternalEmergencyPreparedness/EmergencyNotifications/EmergencyNotifications";
import SendNotification from "./screens/ExternalEmergencyPreparedness/EmergencyNotifications/SendNotification";
import NotificationDetails from "./screens/ExternalEmergencyPreparedness/EmergencyNotifications/NotificationDetails";

// Emergency Preparedness - ERP Execution
import ERPExecutions from "./screens/ExternalEmergencyPreparedness/ERPExecution/ERPExecutions";
import TriggerERP from "./screens/ExternalEmergencyPreparedness/ERPExecution/TriggerERP";
import ExecutionTracker from "./screens/ExternalEmergencyPreparedness/ERPExecution/ExecutionTracker";

// Emergency Preparedness - Monitoring
import MonitoringDashboard from "./screens/ExternalEmergencyPreparedness/Monitoring/MonitoringDashboard";
import AssetInventory from "./screens/UtilitySystems/Asset Inventory & Tracking/AssetInventory";
import UtilityAssetType from "./screens/MasterDataCats/Utlity System/UtlityAssetType/UtilityAssetType";
import ComplianceSafetyDashboard from "./screens/UtilitySystems/ComplianceSafety/ComplianceSafetyDashboard";
import SpaceManagement from "./screens/UtilitySystems/SpaceManagement/SpaceManagement";
import ContractorVendorManagement from "./screens/UtilitySystems/ContractorVendorManagement/ContractorVendorManagement";
import DesignDocumentationIntegration from "./screens/UtilitySystems/DesignDocumentationIntegration/DesignDocumentationIntegration";
import DesignFolderView from "./screens/UtilitySystems/DesignDocumentationIntegration/DesignFolderView";
import ResourceAndReadiness from "./screens/ExternalEmergencyPreparedness/ResourcesAndReadiness/ResourceAndReadiness";
import RoundPlanning from "./screens/SafetyFacilityRounds/RoundPlanning&Scheduling/RoundPlanning";
import ChecklistList from "./screens/SafetyFacilityRounds/Checklists/ChecklistList";
import ChecklistBuilder from "./screens/SafetyFacilityRounds/Checklists/ChecklistBuilder";
import ChecklistExecution from "./screens/SafetyFacilityRounds/Checklists/ChecklistExecution";
import RoundTypeList from "./screens/MasterDataCats/Safety & Facility Rounds/RoundTypeList/RoundTypeList";
import ComplianceAuditDocumentation from "./screens/SafetyFacilityRounds/ComplianceAudit & Documentation/ComplianceAuditDocumentation";
import ComplianceAuditDocumentationFolderView from "./screens/SafetyFacilityRounds/ComplianceAudit & Documentation/FolderView";
import {
  IssueList,
  IssueForm,
  IssueDetails,
} from "./screens/SafetyFacilityRounds/Issues";
import {
  NotificationList,
  EscalationRuleList,
  EscalationRuleForm,
} from "./screens/SafetyFacilityRounds/Notifications";
import ICSIncidents from "./screens/ExternalEmergencyPreparedness/ICS/ICSIncidents";
import ExternalEmergencyIncident from "./screens/ExternalEmergencyPreparedness/ExternalEmergencyIncident";
import EquipmentManagement from "./screens/MasterDataCats/EquipmantManagement/EquipmentManagement";
import EquipmentManagementLanding from "./screens/EquipmentManagement/EquipmentInventoryAndRegistration/EquipmentManagementLanding";
import RfidDemoConsole from "./screens/EquipmentManagement/RfidDemoConsole/RfidDemoConsole";
import MonitoringPage from "./screens/FireSystemMonitoring/MonitoringPage";
import ReportTypeSelectionPage from "./screens/FireSystemMonitoring/ReportTypeSelectionPage";
import MonthSelectionView from "./screens/FireSystemMonitoring/MonthSelectionView";
import TrendsView from "./screens/FireSystemMonitoring/TrendsView";
import ReportViewer from "./screens/FireSystemMonitoring/ReportViewer";
import EquipmentTypeSelectionView from "./screens/FireSystemMonitoring/EquipmentTypeSelectionView";
import EquipmentInspectionListView from "./screens/FireSystemMonitoring/EquipmentInspectionListView";

const FireSafetyTrainingDashboard = withTrainingModule(
  TrainingDashboard,
  FIRE_SAFETY_TRAINING_CONFIG,
);
const FireSafetyCreateTraining = withTrainingModule(
  CreateTraining,
  FIRE_SAFETY_TRAINING_CONFIG,
);
const FireSafetyCreateTest = withTrainingModule(
  CreateTest,
  FIRE_SAFETY_TRAINING_CONFIG,
);
const FireSafetyStartTest = withTrainingModule(
  StartTest,
  FIRE_SAFETY_TRAINING_CONFIG,
);
const FireSafetyAttemptTest = withTrainingModule(
  AttemptTest,
  FIRE_SAFETY_TRAINING_CONFIG,
);
const FireSafetyTrainingView = withTrainingModule(
  TrainingView,
  FIRE_SAFETY_TRAINING_CONFIG,
);
const FireSafetyUpcomingSessions = withTrainingModule(
  UpcomingSessions,
  FIRE_SAFETY_TRAINING_CONFIG,
);
const FireSafetyUpcomingSessionDetails = withTrainingModule(
  UpcomingSessionDetails,
  FIRE_SAFETY_TRAINING_CONFIG,
);
const FireSafetyPastEvaluation = withTrainingModule(
  PastEvaluation,
  FIRE_SAFETY_TRAINING_CONFIG,
);
const FireSafetyPastEvaluationDetails = withTrainingModule(
  PastEvaluationDetails,
  FIRE_SAFETY_TRAINING_CONFIG,
);
const FireSafetyUserTrainingAnalytics = withTrainingModule(
  UserTrainingAnalytics,
  FIRE_SAFETY_TRAINING_CONFIG,
);
const FireSafetyTrainerStartTest = withTrainingModule(
  TrainerStartTest,
  FIRE_SAFETY_TRAINING_CONFIG,
);

interface ProtectedRouteConfig {
  path: string;
  module: string;
  action?: string;
  component: React.FC<any>;
  routeProps?: Record<string, any>;
}

const protectedRoutes: ProtectedRouteConfig[] = [
  {
    path: "/fire-system/dashboard",
    module: FS_DASHBOARD_MODULE,
    component: FsDashboard,
    // action: "read",
  },
  // Fire System Monitoring Routes — new flow: Premises → Report Type → Month → Report
  { path: "/fire-system/monitoring", module: MONITORING_MODULE, component: MonitoringPage },
  { path: "/fire-system/monitoring/:premiseId", module: MONITORING_MODULE, component: ReportTypeSelectionPage },
  { path: "/fire-system/monitoring/:premiseId/:reportType", module: MONITORING_MODULE, component: MonthSelectionView },
  { path: "/fire-system/monitoring/:premiseId/:reportType/trends", module: MONITORING_MODULE, component: TrendsView },
  { path: "/fire-system/monitoring/:premiseId/:reportType/:month", module: MONITORING_MODULE, component: ReportViewer },
  // Equipment Inspections special sub-flow: month → equipment type → inspection list
  { path: "/fire-system/monitoring/:premiseId/equipment-inspections/:month", module: MONITORING_MODULE, component: EquipmentTypeSelectionView },
  { path: "/fire-system/monitoring/:premiseId/equipment-inspections/:month/:equipType", module: MONITORING_MODULE, component: EquipmentInspectionListView },
  // { path: "/fire-system/monitoring/:premiseId/:month/:reportType/:recordId", module: MONITORING_MODULE, component: RecordDetailViewer },
  {
    path: "/tasks",
    module: TASK__MODULE,
    component: Tasks,
  },
  {
    path: "/policies-manuals",
    module: POLICY_MODULE,
    component: PoliciesAndManuals,
    routeProps: { config: fireSafetyConfig },
  },
  {
    path: "/folder/:id",
    module: POLICY_MODULE,
    component: FolderView,
    routeProps: { config: fireSafetyConfig },
  },
  {
    path: "/risk-assessment",
    module: RISKASSES_MODULE,
    component: RiskAssess,
  },
  {
    path: "/budgeting",
    module: BUDGET_MODULE,
    component: Budgeting,
  },
  {
    path: "/safety-equipment",
    module: ASSETS_MODULE,
    component: EquipmentTypesLanding,
  },
  {
    path: "/safety-equipment/:equipmentTypeId",
    module: ASSETS_MODULE,
    component: SafetyEquipment,
  },
  {
    path: "/safety-equipment/inspection/:assetId?",
    module: ASSETS_MODULE,
    component: AssetInspection,
  },
  {
    path: "/safety-equipment/checklist-management",
    module: ASSETS_MODULE,
    component: ChecklistManagement,
  },
  {
    path: "/safety-equipment/fire-safety-scorecard",
    module: ASSETS_MODULE,
    component: KPIScoreCardList,
  },
  {
    path: "/safety-equipment/fire-safety-scorecard/:id",
    module: ASSETS_MODULE,
    component: KPIScoreCard,
  },
  // Backward compatibility
  {
    path: "/safety-equipment/kpi-scorecard",
    module: ASSETS_MODULE,
    component: KPIScoreCardList,
  },
  {
    path: "/safety-equipment/kpi-scorecard/:id",
    module: ASSETS_MODULE,
    component: KPIScoreCard,
  },
  {
    path: "/safety-equipment/fire-safety-mis-checklist",
    module: ASSETS_MODULE,
    component: MISChecklistList,
  },
  {
    path: "/safety-equipment/fire-safety-mis-checklist/:id",
    module: ASSETS_MODULE,
    component: MISChecklist,
  },
  // Backward compatibility
  {
    path: "/safety-equipment/mis-checklist",
    module: ASSETS_MODULE,
    component: MISChecklistList,
  },
  {
    path: "/safety-equipment/mis-checklist/:id",
    module: ASSETS_MODULE,
    component: MISChecklist,
  },
  {
    path: "/safety-equipment/split-ac-checklist",
    module: ASSETS_MODULE,
    component: SplitACChecklistList,
  },
  {
    path: "/safety-equipment/split-ac-checklist/:id",
    module: ASSETS_MODULE,
    component: SplitACChecklistForm,
  },
  {
    path: "/safety-equipment/kpi-checklist",
    module: ASSETS_MODULE,
    component: KPIChecklistManagement,
  },
  {
    path: "/safety-equipment/kpi-checklist-detail/:id",
    module: ASSETS_MODULE,
    component: KPIChecklist,
  },
  {
    path: "/safety-equipment/electrical-safety-scorecard",
    module: ASSETS_MODULE,
    component: ElectricalSafetyScorecardList,
  },
  {
    path: "/safety-equipment/electrical-safety-scorecard/:id",
    module: ASSETS_MODULE,
    component: ElectricalSafetyScorecard,
  },
  /////TRaining//////////
  {
    path: "/trainings/training-dashboard",
    module: TRAINING_MODULE,
    component: FireSafetyTrainingDashboard,
  },
  {
    path: "/trainings/create-planing",
    module: TRAINING_MODULE,
    component: FireSafetyCreateTraining,
    routeProps: { mode: "create" },
  },
  {
    path: "/trainings/update-planing/:id",
    module: TRAINING_MODULE,
    component: FireSafetyCreateTraining,
    routeProps: { mode: "edit" },
  },
  {
    path: "/trainings/view/:id",
    module: TRAINING_MODULE,
    component: FireSafetyCreateTraining,
    routeProps: { mode: "view" },
  },
  {
    path: "/trainings/create-test",
    module: TRAINING_MODULE,
    component: FireSafetyCreateTest,
    routeProps: { mode: "create" },
  },
  {
    path: "/trainings/start-test/:id",
    module: TRAINING_MODULE,
    component: FireSafetyStartTest,
  },
  {
    path: "/trainings/attempt-test/:id",
    module: TRAINING_MODULE,
    component: FireSafetyAttemptTest,
  },
  {
    path: "/trainings/trainer-start-test",
    module: TRAINING_MODULE,
    component: FireSafetyTrainerStartTest,
  },
  {
    path: "/trainings/training-view/:id",
    module: TRAINING_MODULE,
    component: FireSafetyTrainingView,
  },
  {
    path: "/trainings/upcoming-sessions",
    module: TRAINING_MODULE,
    component: FireSafetyUpcomingSessions,
  },
  {
    path: "/trainings/upcoming-session-details/:id",
    module: TRAINING_MODULE,
    component: FireSafetyUpcomingSessionDetails,
  },
  {
    path: "/trainings/past-evaluations",
    module: TRAINING_MODULE,
    component: FireSafetyPastEvaluation,
  },
  {
    path: "/trainings/past-evaluation-details/:id",
    module: TRAINING_MODULE,
    component: FireSafetyPastEvaluationDetails,
  },
  {
    path: "/trainings/user-analytics",
    module: TRAINING_MODULE,
    component: FireSafetyUserTrainingAnalytics,
    action: "read", // Ensure admin access
  },
  //////////////Fire  Drill./////////
  {
    path: "/fire-drill",
    module: FIREDRILL_MODULE,
    component: FireDrills,
  },

  {
    path: "/fire-safety-incident",
    module: INCIDENTS_MODULE,
    component: FireSafteyIncident,
  },

  //   ------------
  {
    path: "/incident-dashboard",
    module: INCIDENT_DASHBOARD,
    component: IMDashboard,
  },
  {
    path: "/incidents",
    module: INCIDENT_LIST,
    component: Incidents,
  },
  {
    path: "/report",
    module: INCIDENT_REPORTS,
    component: Report,
  },
  {
    path: "/premises-information-view/:premiseId",
    module: LAWS_REGULATIONS_MODULE,
    component: PremisesInformationView,
  },

  // Equipment Management Module

  {
    path: "/equipment-management/equipmentTasks",
    module: EQUIPMENT_MANAGEMENT_TASKS,
    component: EquipmentTasks,
  },
  {
    path: "/equipment-management/equipment-inventory-registration",
    module: EQUIPMENT_MANAGEMENT_EQUIPMENT_INVENTORY_REGISTRATION,
    component: EquipmentManagementLanding,
  },
  {
    path: "/equipment-management/equipment-inventory-registration/:id",
    module: EQUIPMENT_MANAGEMENT_EQUIPMENT_INVENTORY_REGISTRATION,
    component: EquipmentInventoryAndRegistration,
  },
  {
    path: "/equipment-management/rfid-demo-console",
    module: EQUIPMENT_MANAGEMENT_EQUIPMENT_INVENTORY_REGISTRATION,
    component: RfidDemoConsole,
  },
  {
    path: "/equipment-management/maintenance-scheduling-and-tracking",
    module: EQUIPMENT_MANAGEMENT_MAINTENANCE_SCHEDULING_AND_TRACKING,
    component: MaintenanceSchedulingAndTracking,
  },
  {
    path: "/equipment-management/maintenance-scheduling-and-tracking/check-list",
    module: EQUIPMENT_MANAGEMENT_MAINTENANCE_SCHEDULING_AND_TRACKING,
    component: CheckList,
  },
  {
    path: "/equipment-management/maintenance-scheduling-and-tracking/create-check-list",
    module: EQUIPMENT_MANAGEMENT_MAINTENANCE_SCHEDULING_AND_TRACKING,
    component: CreateCheckList,
  },
  {
    path: "/equipment-management/maintenance-scheduling-and-tracking/view-check-list",
    module: EQUIPMENT_MANAGEMENT_MAINTENANCE_SCHEDULING_AND_TRACKING,
    component: ViewCheckList,
  },
  {
    path: "/equipment-management/documentation-and-history",
    module: EQUIPMENT_MANAGEMENT_DOCUMENTATION_AND_HISTORY,
    component: DocumentationAndHistory,
  },
  {
    path: "/equipment-management/report-and-analytics",
    module: EQUIPMENT_MANAGEMENT_REPORT_AND_ANALYTICS,
    component: ReportAndAnalytics,
  },
  {
    path: "/equipment-management/incident",
    module: EQUIPMENT_MANAGEMENT_INCIDENT,
    component: EquipmentManagementIncident,
  },
  {
    path: "/equipment-management/budgeting",
    module: EQUIPMENT_MANAGEMENT_BUDGETING,
    component: Budgeting,
  },
  {
    path: "/suppliers",
    module: SUPPLIERS,
    component: SupplierData,
  },
  // External Emergency Preparedness Routes
  {
    path: "/external-emergency-preparedness/dashboard",
    module: EXTERNAL_EMERGENCY_PREPAREDNESS_DASHBOARD,
    component: ExternalEmergencyPreparednessDashboard,
  },
  {
    path: "/external-emergency-preparedness/emergency-response-plans",
    module: EXTERNAL_EMERGENCY_PREPAREDNESS_EMERGENCY_RESPONSE_PLANS,
    component: EmergencyResponsePlans,
  },
  {
    path: "/external-emergency-preparedness/add-response-plan",
    module: EXTERNAL_EMERGENCY_PREPAREDNESS_EMERGENCY_RESPONSE_PLANS,
    component: AddResponsePlan,
  },
  {
    path: "/external-emergency-preparedness/bcp-plans",
    module: EXTERNAL_EMERGENCY_PREPAREDNESS_BUSINESS_CONTINUITY_RECOVERY,
    component: BCPPlans,
  },
  {
    path: "/external-emergency-preparedness/add-bcp-plan",
    module: EXTERNAL_EMERGENCY_PREPAREDNESS_BUSINESS_CONTINUITY_RECOVERY,
    component: AddEditBCPPlan,
  },
  {
    path: "/external-emergency-preparedness/bcp-plans/:planId/recovery-tasks",
    module: EXTERNAL_EMERGENCY_PREPAREDNESS_BUSINESS_CONTINUITY_RECOVERY,
    component: RecoveryTasks,
  },
  {
    path: "/external-emergency-preparedness/bcp-plans/:planId/add-recovery-task",
    module: EXTERNAL_EMERGENCY_PREPAREDNESS_BUSINESS_CONTINUITY_RECOVERY,
    component: AddEditRecoveryTask,
  },
  {
    path: "/external-emergency-preparedness/bcp-plans/:planId/recovery-tasks/:taskId",
    module: EXTERNAL_EMERGENCY_PREPAREDNESS_BUSINESS_CONTINUITY_RECOVERY,
    component: AddEditRecoveryTask,
  },
  {
    path: "/external-emergency-preparedness/bcp-plans/:planId/recovery-timeline",
    module: EXTERNAL_EMERGENCY_PREPAREDNESS_BUSINESS_CONTINUITY_RECOVERY,
    component: RecoveryTimeline,
  },
  {
    path: "/external-emergency-preparedness/testing-drills",
    module: EXTERNAL_EMERGENCY_PREPAREDNESS_TESTING_DRILLS,
    component: FireDrills,
  },
  {
    path: "/external-emergency-preparedness/risk-assessment",
    module: EXTERNAL_EMERGENCY_PREPAREDNESS_RISK_ASSESSMENT,
    component: RiskAssess,
  },
  {
    path: "/external-emergency-preparedness/external-agencies-coordination",
    module: EXTERNAL_EMERGENCY_PREPAREDNESS_EXTERNAL_AGENCIES_COORDINATION,
    component: ExternalAgenciesCoordination,
  },
  {
    path: "/external-emergency-preparedness/resource-for-readiness",
    module: EXTERNAL_EMERGENCY_PREPAREDNESS_RESOURCE_FOR_READINESS,
    component: ResourceAndReadiness,
  },
  {
    path: "/external-emergency-preparedness/incidents",
    module: EXTERNAL_EMERGENCY_PREPAREDNESS_INCIDENTS,
    component: ExternalEmergencyIncident,
  },
  // Utility Systems Routes
  {
    path: "/utility-systems/dashboard",
    module: UTILITY_SYSTEMS_DASHBOARD,
    component: UtilitySystemsDashboard,
  },
  {
    path: "/utility-systems/asset-inventory-tracking",
    module: UTILITY_SYSTEMS_ASSET_INVENTORY_TRACKING,
    component: AssetInventory,
  },
  {
    path: "/utility-systems/contractor-vendor-management",
    module: UTILITY_SYSTEMS_CONTRACTOR_VENDOR_MANAGEMENT,
    component: ContractorVendorManagement,
  },
  // master data
  {
    path: "/utility-asset-type-list",
    module: UTILITY_ASSET_TYPE_LIST,
    component: UtilityAssetType,
  },
  {
    path: "/utility-systems/compliance-safety",
    module: UTILITY_SYSTEMS_COMPLIANCE_SAFETY,
    component: ComplianceSafetyDashboard,
  },
  {
    path: "/utility-systems/space-management",
    module: UTILITY_SYSTEMS_SPACE_MANAGEMENT,
    component: SpaceManagement,
  },
  {
    path: "/utility-systems/design-documentation-integration",
    module: UTILITY_SYSTEMS_DESIGN_DOCUMENTATION_INTEGRATION,
    component: DesignDocumentationIntegration,
  },
  {
    path: "/utility-systems/design-documentation-integration/folder/:id",
    module: UTILITY_SYSTEMS_DESIGN_DOCUMENTATION_INTEGRATION,
    component: DesignFolderView,
  },
  {
    path: "/round-types",
    module: SAFETY_ROUNDS_TYPES,
    component: RoundTypeList,
  },
  {
    path: "/master-data/equipment-management",
    module: EQUIPMENT_MANAGEMENT_MODULE,
    component: EquipmentManagement,
  },

  // Safety & Facility Rounds Routes
  {
    path: "/safety-facility-rounds/dashboard",
    module: SAFETY_FACILITY_ROUNDS_DASHBOARD,
    component: SafetyFacilityRoundsDashboard,
  },
  // Safety & Facility Rounds  Planning & Scheduling
  {
    path: "/safety-facility-rounds/round-planning",
    module: SAFETY_FACILITY_ROUNDS_PLANNING,
    component: RoundPlanning,
  },
  {
    path: "/safety-facility-rounds/checklists",
    module: SAFETY_FACILITY_ROUNDS_CHECKLISTS,
    component: ChecklistList,
  },
  {
    path: "/safety-facility-rounds/checklists/create",
    module: SAFETY_FACILITY_ROUNDS_CHECKLISTS,
    component: ChecklistBuilder,
  },
  {
    path: "/safety-facility-rounds/checklists/edit/:id",
    module: SAFETY_FACILITY_ROUNDS_CHECKLISTS,
    component: ChecklistBuilder,
  },

  {
    path: "/safety-facility-rounds/checklists/view/:id",
    module: SAFETY_FACILITY_ROUNDS_CHECKLISTS,
    component: ChecklistBuilder,
  },
  // Safety & Facility Rounds - Compliance Audit & Documentation
  {
    path: "/safety-facility-rounds/compliance-audit-documentation",
    module: POLICY_MODULE,
    component: ComplianceAuditDocumentation,
  },
  {
    path: "/safety-facility-rounds/compliance-audit-documentation/folder/:id",
    module: POLICY_MODULE,
    component: ComplianceAuditDocumentationFolderView,
  },
  {
    path: "/safety-facility-rounds/checklists/perform/:id",
    module: SAFETY_FACILITY_ROUNDS_CHECKLISTS,
    component: ChecklistExecution,
  },
  // Safety & Facility Rounds - Issues (Feature 4.4)
  {
    path: "/safety-facility-rounds/issues",
    module: SAFETY_FACILITY_ROUNDS_ISSUES,
    component: IssueList,
  },
  {
    path: "/safety-facility-rounds/issues/create",
    module: SAFETY_FACILITY_ROUNDS_ISSUES,
    component: IssueForm,
  },
  {
    path: "/safety-facility-rounds/issues/:id",
    module: SAFETY_FACILITY_ROUNDS_ISSUES,
    component: IssueDetails,
  },
  {
    path: "/safety-facility-rounds/issues/edit/:id",
    module: SAFETY_FACILITY_ROUNDS_ISSUES,
    component: IssueForm,
  },
  // Safety & Facility Rounds - Notifications & Escalations (Feature 4.7)
  {
    path: "/safety-facility-rounds/notifications",
    module: SAFETY_FACILITY_ROUNDS_NOTIFICATIONS,
    component: NotificationList,
  },
  {
    path: "/safety-facility-rounds/notifications/:id",
    module: SAFETY_FACILITY_ROUNDS_NOTIFICATIONS,
    component: NotificationList,
  },
  {
    path: "/safety-facility-rounds/escalation-rules",
    module: SAFETY_FACILITY_ROUNDS_ESCALATION_RULES,
    component: EscalationRuleList,
  },
  // Security Routes
  {
    path: "/security/dashboard",
    module: SECURITY_DASHBOARD,
    component: SecurityDashboard,
  },
  {
    path: "/security/access-control",
    module: SECURITY_ACCESS_ZONES,
    component: AccessControlHub,
  },
  {
    path: "/security/access-control/zones",
    module: SECURITY_ACCESS_ZONES,
    component: AccessZones,
  },
  {
    path: "/security/access-control/assignments",
    module: SECURITY_ACCESS_ASSIGNMENTS,
    component: AccessAssignments,
  },
  {
    path: "/security/access-control/logs",
    module: SECURITY_ACCESS_ZONES,
    component: AccessLogs,
  },
  {
    path: "/security/visitor-management",
    module: SECURITY_VISITOR_MANAGEMENT,
    component: VisitorManagement,
  },
  {
    path: "/security/surveillance",
    module: SECURITY_CAMERAS,
    component: SurveillanceHub,
  },
  {
    path: "/security/surveillance/cameras",
    module: SECURITY_CAMERAS,
    component: Cameras,
  },
  {
    path: "/security/surveillance/live",
    module: SECURITY_CAMERAS,
    component: CameraLivePlayback,
  },
  {
    path: "/security/surveillance/health",
    module: SECURITY_CAMERAS,
    component: SurveillanceHealth,
  },
  {
    path: "/security/surveillance/motion-alerts",
    module: SECURITY_CAMERAS,
    component: MotionAlertsScreen,
  },
  {
    path: "/security/surveillance/heatmap",
    module: SECURITY_CAMERAS,
    component: CrowdHeatmapScreen,
  },
  {
    path: "/security/surveillance/vms",
    module: SECURITY_CAMERAS,
    component: SurveillanceVmsScreen,
  },
  {
    path: "/security/surveillance/incident-clips",
    module: SECURITY_CAMERAS,
    component: IncidentVideoClipsScreen,
  },
  {
    path: "/security/incidents",
    module: SECURITY_INCIDENTS,
    component: SecurityIncidents,
  },
  {
    path: "/security/command-center",
    module: SECURITY_DASHBOARD,
    component: CommandCenterDashboard,
  },
  {
    path: "/security/parking",
    module: SECURITY_PARKING,
    component: ParkingManagement,
  },
  {
    path: "/security/compliance-audit-reporting",
    module: SECURITY_COMPLIANCE_AUDIT,
    component: ComplianceAuditReport,
  },
  {
    path: "/security/compliance-audit",
    module: SECURITY_COMPLIANCE_AUDIT,
    component: ComplianceAuditReport,
  },
  {
    path: "/security/reports",
    module: SECURITY_COMPLIANCE_AUDIT,
    component: ComplianceAuditReport,
  },
  {
    path: "/security/asset-security",
    module: SECURITY_DASHBOARD,
    component: AssetSecurity,
  },
  {
    path: "/security/staff-safety",
    module: SECURITY_DASHBOARD,
    component: StaffSafety,
  },
  {
    path: "/security/cyber-physical",
    module: SECURITY_DASHBOARD,
    component: CyberPhysicalHub,
  },
  {
    path: "/security/ai-predictive",
    module: SECURITY_DASHBOARD,
    component: PredictiveSecurityHub,
  },
  {
    path: "/security/integrations",
    module: SECURITY_DASHBOARD,
    component: SecurityIntegrations,
  },
  {
    path: "/external-emergency-preparedness/hazard-and-vulnerability-assessment",
    module: EXTERNAL_EMERGENCY_PREPAREDNESS_HAZARD_AND_VULNERABILITY_ASSESSMENT,
    component: HazardAndVulnerabilityAssessment,
  },
  // Emergency Preparedness - Communication & Notification
  {
    path: "/external-emergency-preparedness/notifications",
    module: EXTERNAL_EMERGENCY_PREPAREDNESS_DASHBOARD,
    component: EmergencyNotifications,
  },
  {
    path: "/external-emergency-preparedness/send-notification",
    module: EXTERNAL_EMERGENCY_PREPAREDNESS_DASHBOARD,
    component: SendNotification,
  },
  {
    path: "/external-emergency-preparedness/notifications/:id",
    module: EXTERNAL_EMERGENCY_PREPAREDNESS_DASHBOARD,
    component: NotificationDetails,
  },
  // Emergency Preparedness - ERP Execution
  {
    path: "/external-emergency-preparedness/erp-executions",
    module: EXTERNAL_EMERGENCY_PREPAREDNESS_DASHBOARD,
    component: ERPExecutions,
  },
  {
    path: "/external-emergency-preparedness/trigger-erp",
    module: EXTERNAL_EMERGENCY_PREPAREDNESS_DASHBOARD,
    component: TriggerERP,
  },
  {
    path: "/external-emergency-preparedness/erp-executions/:id",
    module: EXTERNAL_EMERGENCY_PREPAREDNESS_DASHBOARD,
    component: ExecutionTracker,
  },
  // Emergency Preparedness - Monitoring
  {
    path: "/external-emergency-preparedness/monitoring",
    module: EXTERNAL_EMERGENCY_PREPAREDNESS_DASHBOARD,
    component: MonitoringDashboard,
  },
  {
    path: "/external-emergency-preparedness/ics",
    module: EXTERNAL_EMERGENCY_PREPAREDNESS_ICS,
    component: ICSIncidents,
  },
  // Utility Systems - Preventive & Predictive Maintenance
  {
    path: "/utility-systems/maintenance/schedules",
    module: PREVENTIVE_PREDICTIVE_MAINTENANCE,
    component: MaintenanceScheduleList,
  },
  {
    path: "/utility-systems/maintenance/logs",
    module: PREVENTIVE_PREDICTIVE_MAINTENANCE,
    component: MaintenanceLogList,
  },
  // Utility Systems - Project Planning & Approvals
  {
    path: "/utility-systems/project-planning",
    module: PROJECT_PLANNING_APPROVALS,
    component: ProjectList,
  },

  // Utility Systems - Budgeting & Cost Control
  {
    path: "/utility-systems/budgeting-cost-control",
    module: BUDGETING_COST_CONTROL,
    component: ProjectPhaseList,
  },
  {
    path: "/utility-systems/budgeting-cost-control/dashboard",
    module: BUDGETING_COST_CONTROL,
    component: ProjectPhaseDashboard,
  },

  // Utility Systems - Infection Control & Safety Planning
  {
    path: "/utility-systems/infection-control",
    module: INFECTION_CONTROL_SAFETY_PLANNING,
    component: InfectionControlChecklistList,
  },
  // Utility Systems - Monitoring & IoT Integration
  {
    path: "/utility-systems/iot/dashboard",
    module: MONITORING_IOT_INTEGRATION,
    component: IoTDashboard,
  },
];

export default protectedRoutes;
